import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { applicationOptions } from '../../stores/applications/selectors';
import { adEnabled, hasPrivilege, hideGroups } from '../../stores/auth/selectors';
import { groupOptions } from '../../stores/groups/selectors';
import { RootState } from '../../stores/store';
import { selectAll, unselectAll } from '../../stores/tables/actionCreators';
import { workspaceOptions } from '../../stores/workspaces/selectors';
import TableColumn from '../table/TableColumn';
import TableFilterableColumn from '../table/TableFilterableColumn';
import TableHead from '../table/TableHead';
import TableSelectionColumn from '../table/TableSelectionColumn';
import TableSortableColumn from '../table/TableSortableColumn';
import {getUsersId} from '../../repositories/UserRepository';
import {getSearch,getFilters} from '../../stores/tables/selectors';
import { TableFilters } from '../../stores/tables/state';


interface Props extends LocalizeContextProps {
    refresh: () => void;
    ids: string[];
    adEnabled?: boolean;
    hideGroups?: boolean;
    hasPrivilege: (names: string[]) => boolean;
    search: string;
    filters :TableFilters;
    selectAll: (ids: string[]) => void;
    unselectAll: (ids: string[]) => void;
    applicationOptions: Array<{ label: string, value: string }>;
    groupOptions: Array<{ label: string, value: string }>;
    workspaceOptions: Array<{ label: string, value: string }>;
    createdAtOptions?: Array<{ label: string, value: string }>;
}

class UsersTableHead extends React.Component<Props> {
    public render() {
        const t = this.props.translate;
        return (
            <TableHead>
                <TableSelectionColumn
                    itemIds={this.props.ids}
                    tableKey="users"
                    selectAll={() =>this.getSelectUsersId()}
                    deselectAll={() => this.getunSelectUsersId()}
                />
                {this.props.hasPrivilege(['SUPER_ADMIN']) ? (
                    <TableColumn />
                ) : null}
                {this.props.adEnabled ? (
                    <TableSortableColumn
                        tableKey="users"
                        column="ad_identifier"
                        refresh={this.props.refresh}
                    >
                        {t('users.table.header.adIdentifier')}
                    </TableSortableColumn>
                ) : null}
                <TableSortableColumn
                    tableKey="users"
                    column="email"
                    refresh={this.props.refresh}
                >
                    {t('users.table.header.email')}
                </TableSortableColumn>
                <TableSortableColumn
                    tableKey="users"
                    column="first_name"
                    refresh={this.props.refresh}
                >
                    {t('users.table.header.firstName')}
                </TableSortableColumn>
                <TableSortableColumn
                    tableKey="users"
                    column="last_name"
                    refresh={this.props.refresh}
                >
                    {t('users.table.header.lastName')}
                </TableSortableColumn>
                <TableFilterableColumn
                    tableKey="users"
                    columnName={t('users.table.header.applications') as string}
                    filterKey="a"
                    options={this.props.applicationOptions}
                    refresh={this.props.refresh}
                />
                {this.props.hideGroups === false ? (
                    <TableFilterableColumn
                        tableKey="users"
                        columnName={t('users.table.header.groups') as string}
                        filterKey="g"
                        options={this.props.groupOptions}
                        refresh={this.props.refresh}
                    />
                ) : null}
                <TableFilterableColumn
                    tableKey="users"
                    columnName={t('users.table.header.workspace') as string}
                    filterKey="w"
                    options={this.props.workspaceOptions}
                    refresh={this.props.refresh}
                />
                <TableSortableColumn
                    tableKey="users"
                    column="createdAt"
                    refresh={this.props.refresh}
                >
                    {t('users.table.header.createdat')}
                </TableSortableColumn>
                <TableColumn className="icon-btn-th" />
                <TableColumn className="icon-btn-th" />
            </TableHead>
        );
    }
private getSelectUsersId():  void
{   
    
    getUsersId(this.props.search,this.props.filters).then
     ( 
      (ids) =>
        this.props.selectAll(ids)   
     );    
    
}
private getunSelectUsersId():  void
{   
     getUsersId(this.props.search,this.props.filters).then
     (
      (ids) =>
        this.props.unselectAll(ids)   
     );        
}
}
const mapStateToProps = (state: RootState) => ({
    adEnabled: adEnabled(state),
    applicationOptions: applicationOptions(state),
    groupOptions: groupOptions(state),
    hasPrivilege: hasPrivilege(state),
    hideGroups: hideGroups(state),
    filters: getFilters(state, 'users'),
    search: getSearch(state, 'users'),
    workspaceOptions: workspaceOptions(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  selectAll: (ids: string[]) => dispatch(selectAll('users', ids)),
  unselectAll: (ids: string[]) => dispatch(unselectAll('users', ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(UsersTableHead));